/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HeatLoadSelectRequestPost } from '../../models/heat-load-select-request-post';
import { HeatLoadSelectResponse } from '../../models/heat-load-select-response';

export interface CalculationsControllerSelect$Params {
      body: HeatLoadSelectRequestPost
}

export function calculationsControllerSelect(http: HttpClient, rootUrl: string, params: CalculationsControllerSelect$Params, context?: HttpContext): Observable<StrictHttpResponse<HeatLoadSelectResponse>> {
  const rb = new RequestBuilder(rootUrl, calculationsControllerSelect.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HeatLoadSelectResponse>;
    })
  );
}

calculationsControllerSelect.PATH = '/planning-projects/v1/calculations/heat-load/select';
